import React, { Fragment, useState } from "react";
import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { store } from "../store";
import { store as globalStore } from "@components/VerticalLayout/store";

import { CustomIcons } from "./CustomIcons";
import VateRateForm from "./VateRateForm";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { useAuthHeader } from "../../../../../api/headersKeycloak";
import { useFetchGlobal } from "../../../../../api/hooks";
import { useSyncDefaultSettingTva, useFetchPays } from "./hooks";

export function Tva() {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();

    const { franchiseID } = useSnapshot(globalStore);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { fetchGlobal } = useFetchGlobal();
    const [filterActive, setLocalFilterActive] = useState<boolean>(false);
    const [isAddVatRateClicked, setIsAddVatRateClicked] = useState<boolean>(
        false
    );
    const [dataIsUpdated, setDataIsUpdated] = useState<boolean | number>(false);
    const [data, setData] = useState<any>({});
    const [rowData, setRowData] = useState<any>({});
    const [pays, setPays] = useState<any>([]);
    const { defaultSetting } = useSnapshot(store);

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 2,
            columnName: t("VAT code"),
            customJsx: (e: any) => (
                <Fragment>{e.selectedRow["Code TVA"]}</Fragment>
            ),
        },
        {
            indexOFColumn: 4,
            columnName: t("VAT rate"),
            customJsx: (e: any) => (
                <Fragment>{e.selectedRow["Taux TVA"]} %</Fragment>
            ),
        },
        {
            indexOFColumn: 997,
            columnName: t("Country"),
            customJsx: (e: any) => <ListOfPays e={e} />,
        },
        {
            indexOFColumn: 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setIsAddVatRateClicked={setIsAddVatRateClicked}
                    setRowData={setRowData}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                />
            ),
            disableFilter: false,
        },
    ];

    const ListOfPays = (e: any) => {
        let listPays: any = [];
        listPays = e.e.selectedRow[t("Country")]?.labels;

        return (
            <CustomColumnDisplay
                text={`${
                    Array.isArray(listPays) ? listPays.join(",") : " -- "
                }`}
            />
        );
    };
    useSyncDefaultSettingTva(data, defaultSetting);
    useFetchPays(fetchGlobal, i18nextLng, setPays);
    return (
        <div>
            <h2 className="mt-3 ml-3">{t("VAT")}</h2>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: isAddVatRateClicked
                        ? "2fr 1fr "
                        : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    requestHeader={{
                        ...getAuthHeader,
                    }}
                    canMovedCheckboxLeftOnExpand
                    url={`${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/getData?type=tva&franchiseId=${franchiseID}`}
                    setData={setData}
                    canSelect
                    customSelect
                    canResize
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight={"450px"}
                    maxHeight={"450px"}
                    name="tva"
                />
                {isAddVatRateClicked ? (
                    <VateRateForm
                        dataVatRate={rowData}
                        setEditedData={setRowData}
                        setIsAddVatRateClicked={setIsAddVatRateClicked}
                        pays={pays}
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        data={data.data}
                        setRowData={setRowData}
                    />
                ) : null}
            </div>
        </div>
    );
}
